export enum validationError {
  invalidFileType = 'invalidFileType',
  invalidFileTypes = 'invalidFileTypes',
  attachmentQuantityExceedsLimit = 'attachmentQuantityExceedsLimit',
  attachmentSizeExceedsLimit = 'attachmentSizeExceedsLimit',
  digitalPropertyKey = 'digitalPropertyKey',
  mobileBundleId = 'mobileBundleId',
  digitalPropertyFieldWorkspaceDuplicate = 'digitalPropertyFieldWorkspaceDuplicate',
  masterLibraryRuleIdDuplicate = 'masterLibraryRuleIdDuplicate',
  customSeveritiesLabelDuplicate = 'customSeveritiesLabelDuplicate',
  userWayWebsiteDuplicate = 'userWayWebsiteDuplicate',
  notMatchDomain = 'notMatchDomain',
  urlInvalid = 'urlInvalid',
  in = 'in',
  maxlength = 'maxlength',
  datesValidator = 'datesValidator',
  maxDateRange = 'maxDateRange',
  endDateBeforeStartDate = 'endDateBeforeStartDate',
  charactersOnly = 'charactersOnly',
  invalidJSON = 'invalidJSON',
  invalidSubdomain = 'invalidSubdomain',
  invalidDate = 'invalidDate',
  minDate = 'minDate',
  maxDate = 'maxDate',
  alphaNumericCharactersOnly = 'alphaNumericCharactersOnly',
  nonEmojiCharactersOnly = 'nonEmojiCharactersOnly',
  designRuleIdPattern = 'designRuleIdPattern',
  invalidInteger = 'invalidInteger',
  unique = 'unique',
  required = 'required',
  invalidZeroInt = 'invalidZeroInt',
  invalidBrowserFlag = 'invalidBrowserFlag',
  readOnlyBrowserFlag = 'readOnlyBrowserFlag',
  nonexistentBrowserFlag = 'nonexistentBrowserFlag',
  duplicateBrowserFlag = 'duplicateBrowserFlag',
  invalidHmacSharedSecret = 'invalidHmacSharedSecret',
  invalidHeaderValue = 'invalidHeaderValue',
  invalidHeaderKey = 'invalidHeaderKey',
  ruleDisabled = 'ruleDisabled',
  invalidComplexityCounts = 'invalidComplexityCounts',
}

export const DEFAULT_ENTRY_LIMITS: readonly number[] = Object.freeze([5, 10, 20]);
export const LARGE_ENTRY_LIMITS: readonly number[] = Object.freeze([10, 20, 50, 100]);
export const FINDING_TABLE_ENTRY_LIMITS: readonly number[] = Object.freeze([25, 50, 100]);
export const COMMON_FINDINGS_TABLE_ENTRY_LIMITS: readonly number[] = Object.freeze([25, 50, 100]);
export const DEFAULT_PAGINATION_MAX_SIZE: number = 3;
